import type { Plugin } from './plugin'
import { State } from './state'

/**
 * Selectors for the records bulk functional usage workflow.
 */
export class Selectors {
  /** Whether a bulk functional usage update is in progress */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isUpdating

  /** Methodology as edited by the user */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly methodology

  /** Allocations as edited by the user */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly functionalizations

  /** Service center as edited by the user */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly serviceCenterId

  /** Whether a bulk functional usage request is in flight */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isSubmitting

  /** Error from the last bulk functional usage request, if there was one */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly error

  constructor(plugin: Plugin) {
    this.isUpdating = plugin.feature.state.project(State.isUpdating)
    this.methodology = plugin.feature.state.project(
      state => state.update?.functionalizationMethodology,
    )
    this.functionalizations = plugin.feature.state.project(
      state => state.update?.functionalizations ?? [],
    )
    this.serviceCenterId = plugin.feature.state.project(
      state => state.update?.serviceCenterId,
    )
    this.isSubmitting = plugin.feature.state.project(state => state.isSubmitting)
    this.error = plugin.feature.state.project(state => state.error)
  }
}
